// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableSkeleton_tableContainer__LuPdI","table":"TableSkeleton_table__TRQM8","skeleton":"TableSkeleton_skeleton__LfVg8","shimmer":"TableSkeleton_shimmer__WDVVZ"};